import { PATH } from "constants/path";
import { queryClient } from "index";

export const handleLogout = () => {
  localStorage.clear();
  localStorage.setItem("i18nLng", "ct");
  localStorage.setItem("i18nextLng", "ct");
  queryClient.resetQueries();
  queryClient.clear();
  if (window.location.pathname !== PATH.Home) {
    window.location.href = PATH.Home;
  }
  window.location.reload();
};
